import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

const searchUrl =
  '/++api++/@search?portal_type=Document&metadata_fields=effective&metadata_fields=created&sort_on=effective&sort_order=descending&b_size=200';

const normalizePath = (url) => {
  try {
    return new URL(url).pathname;
  } catch {
    return url;
  }
};

const ArticlePager = ({ content }) => {
  const [pager, setPager] = React.useState(null);

  React.useEffect(() => {
    let cancelled = false;

    async function loadPager() {
      try {
        const response = await fetch(searchUrl, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        const data = await response.json();
        const items = data.items || [];
        const currentPath = normalizePath(content['@id']);
        const index = items.findIndex(
          (item) => normalizePath(item['@id']) === currentPath,
        );

        if (index === -1 || cancelled) return;
        setPager({
          newer: index > 0 ? items[index - 1] : null,
          older: index < items.length - 1 ? items[index + 1] : null,
        });
      } catch {
        // Keep the article page readable if the optional pager lookup fails.
      }
    }

    loadPager();

    return () => {
      cancelled = true;
    };
  }, [content]);

  if (!pager?.newer && !pager?.older) return null;

  return (
    <nav className="ehon-article-pager" aria-label="前後の記事">
      {pager.older ? (
        <UniversalLink href={flattenToAppURL(pager.older['@id'])}>
          <span>前の記事</span>
          <strong>{pager.older.title}</strong>
        </UniversalLink>
      ) : (
        <span />
      )}
      {pager.newer ? (
        <UniversalLink href={flattenToAppURL(pager.newer['@id'])}>
          <span>次の記事</span>
          <strong>{pager.newer.title}</strong>
        </UniversalLink>
      ) : (
        <span />
      )}
    </nav>
  );
};

ArticlePager.propTypes = {
  content: PropTypes.shape({
    '@id': PropTypes.string,
  }).isRequired,
};

export default ArticlePager;
